import React, { useCallback, useMemo } from 'react';
import { ReduxState, useAppDispatch } from '../../../store';
import { useSelector } from 'react-redux';
import { AvailableModals, closeModal } from '../modalSlice';
import { Image, Modal, Tabs } from 'antd';
import BoxPackingPictures from './BoxPackingPictures';

const modalId = AvailableModals.BOX_PACKING_PICTURES;
const cancelButtonStyle = { style: { display: 'none' } };

/**
 * Display a modal with tabs for each box containing packing pictures.
 * Click on a picture to see it in full size and navigate between pictures.
 */
const BoxPackingPicturesModal: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();

  const open = useSelector((state: ReduxState) => state.modal.openedModal === modalId);
  const modalData = useSelector((state: ReduxState) => state.modal.modalData[modalId]);

  const onCloseModal = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const tabItems = useMemo(
    () =>
      modalData?.boxes.map(box => {
        return {
          key: `box-${box.boxNumber}`,
          label: `Box ${box.boxNumber}`,
          forceRender: true,
          children: (
            <BoxPackingPictures
              boxNumber={box.boxNumber}
              calculationId={modalData.calculationId}
              sourceStoreId={modalData.sourceStoreId}
              targetStoreId={modalData.targetStoreId}
              packingPictureTypes={box.packingPictureTypeIds}
            />
          ),
        };
      }),
    [modalData],
  );

  return (
    <Modal
      title="Box Packing Pictures"
      open={open}
      onOk={onCloseModal}
      onCancel={onCloseModal}
      cancelButtonProps={cancelButtonStyle}
      width="80vw"
      height="75vh"
      style={{ top: 20 }}
    >
      <Image.PreviewGroup>{tabItems && <Tabs items={tabItems} />}</Image.PreviewGroup>
    </Modal>
  );
};

export default BoxPackingPicturesModal;
